import { getENV } from './env';

export function getCWEA() {
    const { NEXT_PUBLIC_CWEA_PROXY_URL_CA, NEXT_PUBLIC_CWEA_PROXY_URL_US, NEXT_PUBLIC_LOCALE } = getENV();
    const config = { 'en-US': NEXT_PUBLIC_CWEA_PROXY_URL_US, 'en-CA': NEXT_PUBLIC_CWEA_PROXY_URL_CA };

    return config[NEXT_PUBLIC_LOCALE];
}
